import { DateTime } from 'luxon';

export function refineTimeStampArray(timeStampArray, timeUnit, scaleX) {
  let formatObj;
  if (
    timeUnit === 'DAYS' ||
    timeUnit === 'WEEKS' ||
    timeUnit === 'MONTHS' ||
    timeUnit === 'YEARS'
  ) {
    formatObj = { month: 'numeric', day: 'numeric' };
  } else formatObj = DateTime.TIME_24_SIMPLE;
  if (timeStampArray.length > 160) {
    return timeStampArray.reduce((acc, timeStamp, index) => {
      if (index % 32 === 0)
        return [
          ...acc,
          {
            xPos: scaleX(index),
            time: DateTime.fromMillis(timeStamp)
              .setZone('America/New_York')
              .toLocaleString(formatObj),
          },
        ];
      else return acc;
    }, []);
  }
  if (timeStampArray.length > 80) {
    return timeStampArray.reduce((acc, timeStamp, index) => {
      if (index % 16 === 0)
        return [
          ...acc,
          {
            xPos: scaleX(index),
            time: DateTime.fromMillis(timeStamp)
              .setZone('America/New_York')
              .toLocaleString(formatObj),
          },
        ];
      else return acc;
    }, []);
  }
  if (timeStampArray.length > 40) {
    return timeStampArray.reduce((acc, timeStamp, index) => {
      if (index % 8 === 0)
        return [
          ...acc,
          {
            xPos: scaleX(index),
            time: DateTime.fromMillis(timeStamp)
              .setZone('America/New_York')
              .toLocaleString(formatObj),
          },
        ];
      else return acc;
    }, []);
  }
  if (timeStampArray.length > 20) {
    return timeStampArray.reduce((acc, timeStamp, index) => {
      if (index % 4 === 0)
        return [
          ...acc,
          {
            xPos: scaleX(index),
            time: DateTime.fromMillis(timeStamp)
              .setZone('America/New_York')
              .toLocaleString(formatObj),
          },
        ];
      else return acc;
    }, []);
  }
  if (timeStampArray.length > 10) {
    return timeStampArray.reduce((acc, timeStamp, index) => {
      if (index % 2 === 0)
        return [
          ...acc,
          {
            xPos: scaleX(index),
            time: DateTime.fromMillis(timeStamp)
              .setZone('America/New_York')
              .toLocaleString(formatObj),
          },
        ];
      else return acc;
    }, []);
  }
  return timeStampArray.map((timeStamp, index) => ({
    xPos: scaleX(index),
    time: DateTime.fromMillis(timeStamp)
      .setZone('America/New_York')
      .toLocaleString(formatObj),
  }));
}
